import {Component, Input} from '@angular/core';
import {AlarmTile, AlarmZoneTile} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService
} from "../../../core";
import {StateService} from "@uirouter/core";
import {AlarmMessageData} from "../../../models/alarms";
import {FormatPipe} from "../../../shared";

@Component({
    selector: 'tile-alarm',
    templateUrl: './tile-alarm.component.html',
    styleUrls: ['./tile-alarm.component.scss']
})
export class TileAlarmComponent {
    @Input() tile: AlarmTile;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
        private formatPipe: FormatPipe,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }

    formatAlarmText(data: AlarmTile): string {
        const subtitle = this.subtitles.setSubtitle(data.txtId);
        const unit = typeof data.unit === 'number' ? data.unit : 0;
        const valueWithUnit = this.formatPipe.transform(data.value, unit);
        return `${subtitle} ${valueWithUnit}`;
    }
}
